export const defaultIsoDateFormat = (value?: string) => {
  if (!value) {
    return null;
  }

  return new Date(value);
};
